import { Box, Typography } from "@mui/material";

const Traits = () => {
  return (
    <Box
      sx={{
        px: 3,
        py: 1,
        border: "1px solid lightgray",
        borderRadius: "5px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        bgcolor: "#FFFFFF",
      }}
    >
      <Typography variant='caption' color='gray' fontWeight={"bold"}>
        BACKGROUND
      </Typography>
      <Typography variant='caption' color='black' fontWeight={"bold"}>
        Sonora <span style={{ fontWeight: "normal" }}>6%</span>
      </Typography>
      <Typography variant='caption' color='black'>
        Floor: 5.9 ETH
      </Typography>
    </Box>
  );
};

export default Traits;
